(function () {
  class ScrollContainer extends PIXI.Container {
    constructor() {
      super();

      this._initialised = false;
      this.visible = false;
    }

    initialise() {
      //Scroll Bar: Regular, Hover, Pressed
      this.tints = [0xffffff, 0xc5d1d6, 0x6d94a6];

      //Scroll Background
      this.backgroundColour = 0x2d2d36;

      //Vertical size of all content to be shown
      this.allContentHeight = 0;

      //Stuff that might not appear
      this.itemContainers = [];
      this.itemPositions = [];

      const gapBetweenChildren = 30;
      this.addItems(
        resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer'),
        gapBetweenChildren
      );

      this.allContentHeight -= this.amountRemove;

      // Store the original total content height for orientation change recalculations
      this.totalContentHeight = this.allContentHeight;

      //Sizes of actual scroll window
      this.scrollMax = 1280;
      this.scrollMin = 720;

      this.allContentHeight = this.calculateScrollableHeight();

      //Scrollbar width & height, radius is how round the top/bottom is
      this.scrollBarTotalHeight = 600;
      this.scrollBarWidth = 12;
      this.scrollBarRadius = 6;

      this.scrollBarHeight = (this.scrollMin / this.allContentHeight) * this.scrollBarTotalHeight;
      this.maxScrollBar = this.scrollBarTotalHeight - this.scrollBarHeight;

      this.scrollProgress = 0;

      this.scrollContainer = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer');

      this.mask = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollMask');
      this.mask.beginFill(0xffffff).drawRect(0, 0, 1, 1).endFill();

      this.mask.width = this.scrollMax;
      this.mask.height = this.scrollMin;
      this.scrollContainer.mask = this.mask;

      this.scrollBarBackground = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBarBackground'
      );
      this.scrollBarBackground.beginFill(this.backgroundColour);
      this.scrollBarBackground.drawRoundedRect(
        0,
        0,
        this.scrollBarWidth,
        this.scrollBarTotalHeight,
        this.scrollBarRadius
      );
      this.scrollBarBackground.endFill();

      this.scrollBar = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBar');
      this.scrollBar.beginFill(this.tints[0]);
      this.scrollBar.drawRoundedRect(0, 0, this.scrollBarWidth, this.scrollBarHeight, this.scrollBarRadius);
      this.scrollBar.endFill();

      // this.backgroundFreeSpins = resourceManager.get('helpPageScrollContainer:helpPageScroll:backgroundFreeSpins');
      // this.backgroundFreeSpins.alpha = 0;

      this.closeButton = resourceManager.get('helpPageScrollContainer:helpPageScroll:closeButton');
      this.closeButton.interactive = true;
      this.closeButton.mousedown = () => this.close();
      this.closeButton.touchstart = () => this.close();

      this.areaDown = false;
      this.barDown = false;
      this.barOver = false;
      this.lastPos = null;
      this.lastDiffence = null;
      this.scrollAnim = null;

      const self = this;

      this.touchArea = resourceManager.get('helpPageScrollContainer:helpPageScroll:touchArea');
      this.touchArea.beginFill(0xffffff);
      this.touchArea.lineStyle(0, 0xffffff);
      this.touchArea.drawRect(0, 0, 1, 1);
      this.touchArea.scale.x = 1260;
      this.touchArea.scale.y = 700;
      this.touchArea.x = 10;
      this.touchArea.y = 10;
      this.touchArea.interactive = true;
      this.touchArea.alpha = 0;

      this.touchArea.on('mouseout', function (e) {
        self.areaMouseUp(e);
      });

      this.touchArea.mousemove = (e) => this.areaMouseMove(e);
      this.touchArea.mousedown = (e) => this.areaMouseDown(e);
      this.touchArea.mouseup = (e) => this.areaMouseUp(e);
      this.touchArea.mouseupoutside = (e) => this.areaMouseUp(e);
      this.touchArea.touchmove = (e) => this.areaMouseMove(e);
      this.touchArea.touchstart = (e) => this.areaMouseDown(e);
      this.touchArea.touchend = (e) => this.areaMouseUp(e);
      this.touchArea.touchendoutside = (e) => this.areaMouseUp(e);

      this.scrollBarContainer = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollBarContainer');

      this.scrollBarContainer.interactive = true;
      this.scrollBarContainer.touchmove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousemove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousedown = (e) => this.barMouseDown(e);
      this.scrollBarContainer.mouseup = (e) => this.barMouseUp(e);
      this.scrollBarContainer.mouseupoutside = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchstart = (e) => this.barMouseDown(e);
      this.scrollBarContainer.touchend = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchendoutside = (e) => this.barMouseUp(e);

      this.scrollBarContainer.on('mouseover', function (e) {
        self.barOver = true;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[1];
        }
      });
      this.scrollBarContainer.on('mouseout', function (e) {
        self.barOver = false;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[0];
        }
      });

      //PIXI v4 doesn't seem to support mouse wheel so using event listener
      addEventListener('wheel', (e) => this.areaMouseWheel(e));

      Reflex.registerEventHandler('orientationChange', this.orientationChange.bind(this));

      messageBus.subscribe('game:modal', this.onModal.bind(this));

      this.orientationChange();
    }

    barMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };

      this.scrollBar.tint = this.tints[2];
      this.barDown = true;
    }

    barMouseUp(e) {
      this.scrollBar.tint = this.barOver ? this.tints[1] : this.tints[0];
      this.barDown = false;
      this.areaDown = false;
    }

    barMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        const yPos = this.scrollBarContainer.y;
        const min = this.scrollBarTotalHeight;
        const max = gdk.getScreenHeight() - yPos;
        const pos = (min / max) * (clientY - yPos);

        this.scrollBar.y = pos;

        this.barCap();
        this.scrollProgress = this.scrollBar.y / this.maxScrollBar;
        this.setAreaProgress();
      }
    }

    orientationChange() {
      // If help screen is currently open, make sure to hide game container artifacts
      if (this.helpActive) {
        this.hideGameContainerArtifacts();
      }

      if (systemData.isLandscape) {
        this.mask.width = this.scrollMax;
        this.mask.height = this.scrollMin;

        this.touchArea.scale.x = 1260;
        this.touchArea.scale.y = 700;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      } else {
        this.mask.width = this.scrollMin;
        this.mask.height = this.scrollMax;

        this.touchArea.scale.x = 700;
        this.touchArea.scale.y = 1260;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      }

      // Recalculate content height based on new orientation
      this.allContentHeight = this.calculateScrollableHeight();

      // Recalculate scrollbar dimensions for new content height
      this.scrollBarHeight = (this.scrollMin / this.allContentHeight) * this.scrollBarTotalHeight;
      this.maxScrollBar = this.scrollBarTotalHeight - this.scrollBarHeight;

      // Redraw scrollbar with new dimensions
      this.scrollBar.clear();
      this.scrollBar.beginFill(this.tints[0]);
      this.scrollBar.drawRoundedRect(0, 0, this.scrollBarWidth, this.scrollBarHeight, this.scrollBarRadius);
      this.scrollBar.endFill();

      for (let i = 0; i < this.itemContainers.length; i++) {
        this.itemContainers[i].y = this.itemPositions[i];
      }

      this.setAreaProgress();
      this.scrollDistanceCap();
    }

    calculateScrollableHeight() {
      const currentLayout = layoutController.getCurrentLayout();
      let bottomPadding;

      // Portrait modes need more bottom padding due to taller viewport
      if (currentLayout === 'portrait_default' || currentLayout === 'portrait_mobile') {
        bottomPadding = 900;
      } else {
        // Landscape modes (landscape_default, landscape_mobile, etc.)
        bottomPadding = 400;
      }

      return this.totalContentHeight - bottomPadding;
    }

    open() {
      if (!this._initialised) {
        this._initialised = true;
        this.initialise();
      }

      this.helpActive = true;
      this.hideGameContainerArtifacts();
      this.visible = true;

      messageBus.post('game:modal', {
        reason: 'Options menu open',
      });

      this.scrollProgress = 0;
      this.setAreaProgress();
      this.setBarProgress();

      this.updateFairnessText();
    }

    updateFairnessText() {
      this._fairnessText = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:rtpMaxWin:rtp'
      );

      var stakeController = resourceManager.getController('stakeController');
      var stake = stakeController.CurrentStake;
      var stakeIndex = stakeController.SelectedStakeIndex;
      var baseStake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
      var rtp = gameData.slotConfig.RTP[stakeIndex] * 100;

      this._fairnessText.setTranslationParameters(
        gdk.formatCurrency(stake),
        gdk.formatCurrency(baseStake * gameData.maxExposure),
        rtp.toFixed(1) + '%'
      );

      this._fishAmountText = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:featureFishInfoPage:helpImageAmount'
      );
      this._fishAmountText.setText(
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal((stake * 5) / 100)
      );

      this._cashPotAmountText = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:cashFish:helpImageAmount'
      );
      this._cashPotAmountText.setText(
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal((stake * 15) / 100)
      );

      const versionText = resourceManager.get('helpPageScrollContainer:helpPageScroll:versionText');
      const versionStr =
        'v ' +
        gameData.gameVersionMajor +
        '.' +
        gameData.gameVersionMinor +
        '.' +
        gameData.gameVersionBugFix +
        '\n(' +
        gameData.gameReleaseDate +
        ')';
      versionText.setText(versionStr);
    }

    close() {
      this.helpActive = false;
      this.restoreGameContainerArtifacts();
      this.visible = false;

      messageBus.post('game:modal', {});

      soundManager.play('buttonPressed');
    }

    /**
     * Hides various game container artifacts by setting their visibility to false.
     * This method ensures that specific game elements, such as reels and slot containers,
     * are not visible in the help pages.
     */
    hideGameContainerArtifacts() {
      resourceManager.get('buttonContainer').visible = false;
      resourceManager.get('meterContainer').visible = false;
      resourceManager.get('particlesContainerFront').visible = false;
      resourceManager.get('preReels').visible = false;
      resourceManager.get('preReelsNudge').visible = false;
      resourceManager.get('slotContainer').visible = false;
      resourceManager.get('nudgeSlotContainer').visible = false;
      resourceManager.get('postReels').visible = false;
      resourceManager.get('postReelsNudge').visible = false;
      resourceManager.get('symbolOverlayDisplay').visible = false;
    }

    /**
     * Restores the visibility of various game container artifacts.
     * This method ensures that specific game elements, such as pre-reels,
     * slot containers, and post-reels, are reshown when the help page is closed.
     */
    restoreGameContainerArtifacts() {
      resourceManager.get('buttonContainer').visible = true;
      resourceManager.get('meterContainer').visible = true;
      resourceManager.get('particlesContainerFront').visible = true;
      resourceManager.get('preReels').visible = true;
      resourceManager.get('preReelsNudge').visible = true;
      resourceManager.get('slotContainer').visible = true;
      resourceManager.get('nudgeSlotContainer').visible = true;
      resourceManager.get('postReels').visible = true;
      resourceManager.get('postReelsNudge').visible = true;
      resourceManager.get('symbolOverlayDisplay').visible = true;
    }

    setAreaProgress() {
      this.scrollContainer.y = -this.allContentHeight * this.scrollProgress;

      this.animateBackground();
    }

    setBarProgress() {
      if (this.scrollContainer.y == 0) {
        this.scrollProgress = 0;
      } else {
        this.scrollProgress = -this.scrollContainer.y / this.allContentHeight;
      }

      this.animateBackground();

      this.scrollBar.y = this.scrollProgress * (this.scrollBarTotalHeight - this.scrollBarHeight);
    }

    animateBackground() {
      // this.backgroundFreeSpins.alpha = this.scrollProgress;
    }

    areaMouseWheel(e) {
      if (this.scrollContainer.y <= 0 && -this.scrollContainer.y <= this.allContentHeight) {
        this.scrollContainer.y -= e.deltaY;
      }

      this.scrollDistanceCap();
    }

    barCap() {
      this.scrollBar.y = Math.min(Math.max(this.scrollBar.y, 0), this.maxScrollBar);
    }

    scrollDistanceCap() {
      this.scrollContainer.y = Math.min(Math.max(this.scrollContainer.y, -this.allContentHeight), 0);

      this.setBarProgress();
    }

    areaMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.areaDown && !this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        if (this.scrollContainer.y <= 0 && -this.scrollContainer.y <= this.allContentHeight) {
          this.scrollContainer.y += this.lastDiffence;
        }

        this.scrollDistanceCap();
      }
    }

    areaMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;
      this.areaDown = true;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };
    }

    areaMouseUp() {
      const minSpeed = 5;

      const duration = Math.abs(this.lastDiffence / 50);

      const gotoY = Math.min(Math.max(this.scrollContainer.y + this.lastDiffence * 20, -this.allContentHeight), 0);

      if (this.lastDiffence != null) {
        if (Math.abs(this.lastDiffence) > minSpeed) {
          this.scrollAnim = gsap.to(this.scrollContainer, {
            duration,
            y: gotoY,
            ease: 'power2.out',
            onUpdate: () => {
              this.scrollDistanceCap();
            },
          });
        }
      }

      this.areaDown = false;

      if (!this.barOver) {
        this.lastPos = null;
        this.lastDiffence = null;
        this.scrollBar.tint = this.tints[0];
        this.barDown = false;
      }
    }

    addItems(container, buffer) {
      const items = container.children[0].children;

      this.amountRemove = 0;

      if (items.length === 0) return;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        const condition = item.children[0].parent.Props.condition;
        const customBuffer = item.children[0].parent.Props.customBuffer;

        let height = item.height;

        if (customBuffer) {
          height += customBuffer;
          this.amountRemove += customBuffer;
        } else {
          height += buffer;
        }

        this.addItem(condition, item, height);
      }
    }

    addItem(condition, item, size) {
      if (this.checkCondition(condition)) {
        this.itemPositions.push(this.allContentHeight);
        this.itemContainers.push(item);
        this.allContentHeight += size;
      } else {
        item.visible = false;
      }
    }

    checkCondition(condition) {
      if (condition === undefined) {
        return true;
      }

      return eval(condition);
    }

    onModal(data) {
      if (this.visible) {
        if (data.reason === undefined) {
          messageBus.post('game:modal', {
            reason: 'Options menu open',
          });
        }
      }
    }
  }

  let scrollContainerCreator = function (json) {
    return new ScrollContainer();
  };

  resourceManager.registerObjectType(
    'scrollContainer',
    scrollContainerCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
